import React, { createContext, useState, useEffect } from 'react';
import { mockDbService } from '../services/mockDatabase';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Initialize the mock database when the app loads
  useEffect(() => {
    mockDbService.init();
  }, []);

  // Check for existing token and get user data when app loads
  useEffect(() => {
    const loadUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const userData = await mockDbService.auth.getCurrentUser();
          setUser(userData);
        }
      } catch (err) {
        console.error('Error loading user:', err);
        // If token is invalid, remove it
        localStorage.removeItem('token');
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, []);

  // Register function
  const register = async (userData) => {
    try {
      setError(null);
      setLoading(true);
      
      const response = await mockDbService.auth.register(userData);
      setUser(response.user);
      return true;
    } catch (err) {
      console.error('Registration error:', err.message || err);
      setError(err.message || 'Registration failed');
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Login function
  const login = async (email, password) => {
    try {
      setError(null);
      setLoading(true);
      
      const response = await mockDbService.auth.login(email, password);
      setUser(response.user);
      return true;
    } catch (err) {
      console.error('Login error:', err.message || err);
      setError(err.message || 'Login failed');
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Logout function
  const logout = async () => {
    try {
      await mockDbService.auth.logout();
      setUser(null);
      return true;
    } catch (err) {
      console.error('Logout error:', err.message || err);
      return false;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        error,
        isAuthenticated: !!user,
        login,
        register,
        logout,
        setError
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};